import React from 'react';
import CountriesWeather from "./components/CountriesWeather";
import './App.css';

function App() {
  return (
    <div>
      <CountriesWeather  />
    </div>
  );
}

export default App;
